import { render, staticRenderFns } from "./BasisSelect.vue?vue&type=template&id=a4131856&scoped=true"
import script from "./BasisSelect.vue?vue&type=script&lang=js"
export * from "./BasisSelect.vue?vue&type=script&lang=js"
import style0 from "./BasisSelect.vue?vue&type=style&index=0&id=a4131856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4131856",
  null
  
)

export default component.exports